import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICDCode } from '../../model/v2/global-data/icdcode';
import { GlobalHealthSystem } from '../../model/v2/healthSystem/global-health-system';
import { Practitioner } from '../../model/v2/practitioner/practitioner';
import { BaseService } from '../shared/base.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalDataService {

  constructor(private baseService: BaseService) { }

  searchGlobalHealthSystem(npi: string): Observable<GlobalHealthSystem> {
    return this.baseService.anonymousGet<GlobalHealthSystem>(`GlobalData/GetGlobalHealthSystemDetailsByNPI?npi=${npi}`);
    // return this.httpClient.get<any>('/api/get?url=' + `v2/GlobalData/GetGlobalHealthSystemDetailsByNPI?npi=${npi}`);
  }

  searchPhysicians(npi: string): Observable<Practitioner> {
    return this.baseService.get<Practitioner>(`GlobalData/GetGlobalPractitionerDetailsByNPI?npi=${npi}`);
  }

  getICDCodes(filter: string): Observable<ICDCode[]> {
    return this.baseService.get<any>(`GlobalData/GetGlobalICDCodes?filter=${filter}`);
  }

  validateICDCode(icdCode: string): Observable<any> {
    return this.baseService.get<any>(`GlobalData/ValidateICDCode?ICDCode=${icdCode}`);
  }
}
